const dayjs = require('dayjs');

export default function buildProgressMessages() {
  // Theme: 3 different modes of transport. Plane, roadtrip, ship
  const minute = dayjs().format('m');
  // THEME: Plane
  let buildProgress1 =
    'Checking your blog in for a first-class flight to the web!';
  let buildProgress2 =
    'Hang in there, your blog is just getting its boarding pass!';
  let buildProgress3 = `Fasten your seatbelts, your blog's taking off on its big trip!`;
  let buildProgress4 =
    'Time to fly! Your blog is reaching new heights as it jets off to the world wide web.';
  let buildProgress5 =
    'Watch out, internet! This blog is coming in for a smooth landing on your runway.';
  let buildProgress6 = 'Fighting jetlag with caffeine and naps.';
  let buildQueued =
    'Your blog is getting the VIP treatment from airport security. Just a few extra checks before it jets off to fame and fortune.';
  let buildFailed = `Uh oh, looks like your blog's plane had to make an emergency landing, but no need to panic.`;
  if (minute > 20) {
    // THEME: Roadtrip
    buildProgress1 = 'Preparing for road trip, packing pixels.';
    buildProgress2 =
      'Hold on to your sunscreen, your blog is almost ready to hit the road!';
    buildProgress3 =
      'Your blog is packed, fueled up, and ready to roll. Buckle up!';
    buildProgress4 =
      'Embarking on a journey through the vast digital landscape.';
    buildProgress5 = 'Cruising down the highway, destination: internet fame!';
    buildProgress6 = "The GPS says we're almost at the web, hang tight!";
    buildQueued =
      'Your blog is waiting in a traffic jam, but it will continue its journey shortly.';
    buildFailed =
      'Uh oh, your blog encountered a roadblock on the cyber highway.';
  }
  if (minute > 40) {
    // Theme: Ship
    buildProgress1 =
      'Captain Blogbeard has given the order to cast off and set sail for the internet!';
    buildProgress2 = `Sit tight, we're just giving your blog a passport stamp and sending it on its way!`;
    buildProgress3 = 'All aboard for a voyage across the web!';
    buildProgress4 =
      'Sailing smoothly towards our destination, the world wide web.';
    buildProgress5 =
      'Navigating through the vast seas of the web. Next stop: internet fame!';
    buildProgress6 =
      "Your blog's ship is almost there! You can practically see the internet on the horizon!";
    buildQueued =
      "Hold on tight, we're waiting for the rough seas to calm down before setting sail again!";
    buildFailed = `Oh no, looks like your blog's ship hit some rough waters and needs some repairs.`;
  }

  return {
    buildProgress1,
    buildProgress2,
    buildProgress3,
    buildProgress4,
    buildProgress5,
    buildProgress6,
    buildQueued,
    buildFailed,
  };
}

buildProgressMessages();
